import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../genericComponents/forms/GenericFormHeaderComponent'
import GenericCustomButton from '../../genericComponents/GenericCustomButton';
import NoDataFound from '../../genericComponents/NoDataFound';
import { TriangleAlert } from 'lucide-react';

function ErrorLogsDetails(props) {

    const { focusedElement, setFocusedElement, selectedData = {}, setCurrentExpandedBreakpoint, currentTab, setCurrentTab } = props;

    const [errorsData, setErrorsData] = useState({})

    function parseValidationResponse(data) {
        const grouped = {
            mandatory: [],
            dataIssues: [],
            mismatched: [],
            extinct: [],
        };

        Object.entries(data).forEach(([row, data]) => {
            const { address, errorMessage } = data;

            const addErrors = (ids, category) => {
                if (!ids) return;
                ids.split(",").forEach(id => {
                    if (id.trim()) {
                        grouped[category].push({
                            id,
                            breakPoint: row,
                            message: errorMessage[id]
                        });
                    }
                });
            };

            addErrors(address?.mandate, "mandatory");
            addErrors(address?.dataIssue, "dataIssues");
            addErrors(address?.mismatch, "mismatched");
            addErrors(address?.ext, "extinct");
        });

        return grouped;
    }

    useEffect(() => {
        if(Object.keys(selectedData)?.length) {
            let data = parseValidationResponse(selectedData)
            setErrorsData(data)
        }
    }, []);

    const getErrorType = {
        mandatory: "Mandatory Issue",
        dataIssues: "Data Issues",
        mismatched: "Mismatched",
        extinct: "Extinct"
    }

    const getDivStyle = {
        mandatory: "bg-[#55555533] text-[#555555] border border-[#55555533] hover:border-[#555555]",
        dataIssues: "bg-[#E1705533] text-[#E17055] border border-[#E1705533] hover:border-[#E17055]",
        mismatched: "bg-[#D6303133] text-[#D63031] border border-[#D6303133] hover:border-[#D63031]",
        extinct: "bg-[#FFB93633] text-[#FFB936] border border-[#FFB93633] hover:border-[#FFB936]"
    }

    const getActiveDivStyle = {
        mandatory: 'bg-[#555555] border border-[#555555] text-white',
        dataIssues: 'bg-[#E17055] border border-[#E17055] text-white',
        mismatched: 'bg-[#D63031] border border-[#D63031] text-white',
        extinct: 'bg-[#FFB936] border border-[#FFB936] text-white'
    }

    const handleChange = (type, data) => {
        switch (type) {
            case "getCurrentErrors":
                setCurrentTab(data);
                break;
            case "focusOnError": {
                setCurrentExpandedBreakpoint(data?.breakPoint);
                setFocusedElement(data?.id);
                props?.closeModal?.();
                break;
            }
            default:
                break;
        }
    }

    return (
        <div className='flex flex-col h-full'>
            <GenericFormHeaderComponent
                headerClassName='border-b border-b-borderSlateGrey'
                label={{
                    contentPrimary: ()=><div className='flex items-center gap-2'><TriangleAlert size={24} strokeWidth={2.3} color='#FD3757' className='shrink-0' /><h4>Error Logs Details</h4></div>
                }}
                closeModal={props?.closeModal}
            />
            <div className='px-[15px] py-3 h-full flex flex-col overflow-auto'>
                <div className='mb-4 flex items-center gap-3'>
                    {Object.keys(getErrorType)?.map((key) => <div className={`px-3 py-2 w-full rounded-[5px] cursor-pointer ${currentTab === key ? getActiveDivStyle?.[key] : getDivStyle?.[key]}`} onClick={() => handleChange("getCurrentErrors", key)}>
                        <p className='mb-0.5 text-xl font-bold'>{errorsData?.[key]?.length}</p>
                        <p className={`mb-0 text-[11px] whitespace-nowrap ${currentTab === key ? 'text-white font-semibold' : 'text-black'}`}>{getErrorType[key]}</p>
                    </div>)}
                </div>

                <div className='space-y-0.5 h-full flex flex-col overflow-auto'>
                    {errorsData?.[currentTab]?.length > 0 ? errorsData?.[currentTab]?.map((item) => (
                    <div onClick={() => handleChange("focusOnError", item)} className={`px-1.5 py-2 flex items-start gap-1.5 rounded-[5px] cursor-pointer hover:bg-[#FD375714] ${focusedElement == item?.id ? 'bg-[#FD375714]' : ''}`}>
                            <TriangleAlert size={13} strokeWidth={2.3} color='#FD3757' className='mt-[2px] shrink-0' />
                            <p className='mb-0 text-xs text-[#4A5D7A]'>
                                <span className='text-[13px] font-semibold text-fontBlack'>{item?.id} - </span>
                                {item?.message}
                            </p>
                        </div>)
                    ) : <div className='h-full flex items-center justify-center'><NoDataFound /></div>}
                </div>
            </div>
        </div>
    )
}

export default ErrorLogsDetails